import { TranslationResource } from './en';

// Spanish translations must follow the same structure as English
const es: TranslationResource = {
  translation: {
  select_a_community: 'Seleccionar una comunidad',
  no: 'No',
  yes: 'Sí',
  flu_symptoms_question: '¿Usted o alguna otra persona que visitará la vivienda tiene síntomas similares a los de la gripe?',
  tour_not_found: 'No se encontró la visita',
  cancel_tour: 'Cancelar visita',
  confirm_cancel_tour: '¿Desea cancelar la visita?',
  "policy_decline": "He leído y rechazo la política de comunicaciones de {{builder}}.",
  "network_or_error": "Se ha producido un error o hay un problema de conexión.",
  "generic_error": "Se ha producido un error",
  "create_account_error": "No pudimos crear su cuenta. Inténtelo de nuevo.",
  "register": "Registrarse",
  "temporary_password_sent": "Se ha enviado una contraseña temporal a su correo electrónico. Es válida durante 15 minutos.",
  "enter_email": "Introduzca su correo electrónico.",
  "passwordless_login": "Iniciar sesión sin contraseña",
  "temporary_password_action": "Enviar contraseña temporal.",
  "forgot_password": "¿Olvidó su contraseña?",
  "password": "Contraseña",
  "email": "Correo electrónico",
  "hello": "Hola,",
  "login_below": "Inicie sesión a continuación",
  "nice_to_see": "¡Qué gusto verle de nuevo!",
  "make_permanent": "Complete su registro:",
  "nice_to_meet": "¡Mucho gusto!",
  "next": "Siguiente",
  "resend": "Reenviar.",
  "retry_in": "Inténtelo de nuevo en {{seconds}} s.",
  "having_trouble": "¿Tiene problemas?",
  "enter_otp": "Introduzca el código enviado a su teléfono.",
  "generic_retry": "Se ha producido un error. Inténtelo de nuevo.",
  "otp_invalid": "Código no válido. Inténtelo de nuevo.",
  "otp_not_verified": "El código no se ha verificado. Inténtelo de nuevo o solicite otro.",
  "otp_resend_error": "No se pudo reenviar el código. Inténtelo de nuevo.",
  "otp_sent": "Se ha enviado un nuevo código a su teléfono.",
  "retry_seconds": "Demasiados intentos. Inténtelo de nuevo en {{seconds}} s.",
  "send_code_error": "No se pudo enviar el código. Inténtelo de nuevo.",
  "phone_expired": "La verificación del teléfono ha caducado. Verifique su número de nuevo.",
  "login": "Iniciar sesión",
  "enter_phone": "Introduzca su número de teléfono",
  "phone_verification": "Verificación del teléfono",
  "network_error": "Compruebe su conexión a Internet.",
  "model": "MODELO",
  "square_feet_short": "pies²",
  "half_baths_short": "medios baños",
  "full_baths_short": "baños completos",
  "beds_short": "hab.",
  "per_month": "/mes",
  "property_id": "ID de propiedad",
  "lot": "Lote",
  "no_search_results": "No se encontraron resultados",
  "property_search_placeholder": "Buscar por ID de propiedad, dirección o número de lote",
  "no_community_homes": "Actualmente no hay viviendas disponibles para visitar",
  "community_placeholder": "Seleccione una comunidad",
  "community_question": "¿Qué comunidad le gustaría visitar?",
  "schedule_self_tour": "¡Programe una visita autoguiada presencial!",
  "in_person_tour": "Visita presencial",
  "tour_preference_question": "¿Cómo desea realizar la visita?",
  "required": "obligatorio",
  // Common
  "welcome": "Bienvenido a nuestra aplicación",
  "language": "Idioma",
  "continue": "Continuar",
  "or": "O",
  "need_help": "¿Necesitas ayuda?",
  "powered_by": "Desarrollado por",
  "copyright": "Derechos de autor",
  "header_logo": "Logotipo del constructor",
  "try_again": "Intentar de nuevo",
  "uh_oh": "¡Ups!",
  "community": "Comunidad",
  "accept": "Aceptar",

  // Languages
  "english": "Inglés",
  "spanish": "Español",

  // Authentication
  "sign_in_with_phone": "Inicia sesión con tu número de teléfono.",
  "need_account": "¿Necesitas una cuenta con NterNow?",
  "register_here": "Regístrate aquí",
  "phone_placeholder": "000-000-0000",

  // Navigation
  "back": "Atrás",

  // Errors
  "phone_required": "Se requiere tu número de teléfono. Por favor, vuelve a ingresarlo o regístrate para obtener una cuenta.",
  "property_not_found_title": "Propiedad no encontrada",
  "property_unavailable_title": "Propiedad no disponible",
  "tour_unavailable_title": "Visita no disponible",
  "session_expired_title": "Sesión expirada",
  "tour_restart_needed_title": "Reiniciemos tu visita",
  "temporary_problem_title": "Problema temporal",
  "refresh_needed_title": "Se necesita actualizar",
  "something_went_wrong_title": "Algo salió mal",
  "property_not_found_message": "No se encontró esta propiedad o ya no está disponible.",
  "property_unavailable_message": "Esta propiedad no está disponible para visitas autoguiadas en este momento.",
  "tour_unavailable_message": "Esta visita no se puede iniciar en este momento.",
  "identity_verification_required_message": "Se requiere verificar tu identidad antes de iniciar esta visita.",
  "tour_location_not_confirmed_message": "No pudimos confirmar tu ubicación para esta visita. Comprueba los permisos de ubicación o comunícate con soporte.",
  "adc_backup_code_unavailable_message": "No pudimos obtener un código de acceso para esta propiedad. Inténtalo de nuevo o comunícate con soporte.",
  "session_expired_message": "Tu sesión ha expirado. Por favor, inténtalo de nuevo.",
  "tour_restart_needed_message": "No pudimos continuar la visita anterior. Elige otra propiedad o comunícate con soporte.",
  "temporary_problem_message": "No pudimos cargar esta propiedad debido a un problema temporal de conexión.",
  "refresh_needed_message": "No pudimos actualizar la información de la propiedad. Por favor, inténtalo de nuevo.",
  "something_went_wrong_message": "Algo salió mal al cargar esta propiedad. Por favor, inténtalo de nuevo.",
  "property_id_invalid_message": "El identificador de la propiedad no es válido. Verifícalo e inténtalo de nuevo.",
  "access_problem_retry_help": "Inténtalo de nuevo si el problema es temporal o elige otra propiedad.",
  "access_problem_terminal_help": "Elige otra propiedad o comunícate con soporte para obtener ayuda.",
  "no_active_lock": "Lo sentimos, hay un problema para acceder. No hay una cerradura activa en la propiedad. Por favor, llame al soporte técnico o pruebe con otra propiedad habilitada para visitas.",
  "access_issue": "Lo sentimos, hay un problema para acceder. {propStatusDescription}. Por favor, llame al soporte técnico o pruebe con otra propiedad habilitada para visitas.",
  "accept_terms_error": "Debes aceptar nuestros términos y condiciones para continuar",

  // COVID Notice
  "covid_notice": "Entiendo que durante la crisis de COVID-19, estoy recorriendo bajo mi propio riesgo y me aseguraré de seguir las 5 pautas recomendadas por los CDC al realizar un recorrido autoguiado. Para más información:",
  "covid_policy": "Política de COVID-19",

  // Property viewing
  "select_tour_date": "Seleccionar fecha de visita",
  "previous_tours": "Visitas anteriores",
  "upcoming_tours": "Próximas visitas",
  "choose_community": "Elegir comunidad",
  "search_community": "Buscar comunidad",
  "book_a_tour": "Reservar una visita",
  "tours": "Visitas",
  "enter_property_id": "Ingrese ID de propiedad",
  "property_id_placeholder": "Ingrese el ID de propiedad de 5 dígitos en la puerta",
  "property_label": "Propiedad",
  "explore_other_properties": "Explorar otras propiedades disponibles",
  "find_other_properties": "Encontrar otras propiedades",

  // Account
  "edit_profile": "Editar perfil",
  "my_profile": "Mi perfil",
  "sign_in": "Iniciar sesión",
  "sign_out": "Cerrar sesión",

  // Disclosure
  "disclosure_consent": "Al seleccionar esta casilla, acepto que tengo 18 años o más y acepto ser contactado por NterNow o el propietario o administrador de la propiedad de acuerdo con la",
  "visitor_access_agreement": "Acuerdo de acceso para visitantes",
  "disclosure_intro": "He leído y acepto los siguientes documentos de NterNow:",
  "biometric_policy": "Política de datos biométricos",
  "disclosure_and": "y",
  "visitor_access_agreement_body": "El cliente acepta que cualquier ingreso a la propiedad se realiza bajo su propio riesgo. Por el presente, el cliente renuncia a cualquier reclamación contra {{companyName}} Inc., sus afiliadas, subsidiarias, propietarios, directivos, administradores, empleados, representantes o agentes (en conjunto, «{{companyName}}») por lesiones personales o daños materiales derivados de su ingreso a la propiedad o relacionados con este. El cliente defenderá, indemnizará y mantendrá indemne a {{companyName}} frente a cualquier lesión, pérdida, daño o gasto personal o material derivado de actos u omisiones del cliente o de cualquier persona que lo acompañe a la propiedad. El cliente cumplirá todas las leyes aplicables mientras se encuentre en la propiedad. No proporcionará información ni documentos de identidad falsos. Será responsable de cualquier daño al mobiliario, las instalaciones y los equipos causado directa o indirectamente por él. Si tiene dificultades para visualizar, acceder o navegar por NterNow, comuníquese con nosotros en {{supportEmail}}.",

  // Other pages
  "how_it_works": "Cómo funciona",
  "feedback": "Comentarios",
  "offer": "Oferta",
  "help": "Ayuda",
  "support": "Soporte",
  "privacy_policy": "Política de privacidad",
  "terms_legal": "Términos",
  "terms_of_service": "Términos de servicio",
  "housing_opportunities": "Oportunidades de vivienda",

  "booking_required": "Obligatorio",
  "booking_future_time": "La hora debe ser posterior a la hora actual",
  "booking_property_sold": "La propiedad está vendida",
  "booking_required_label": "obligatorio",
  "booking_lot": "Lote",
  "booking_property_id": "ID de la propiedad",
  "booking_per_month": "/mes",
  "booking_bedrooms_short": "Hab.",
  "booking_full_baths_short": "Baños",
  "booking_half_baths_short": "Medios baños",
  "booking_sqft_short": "pies²",
  "booking_register_to_tour": "Regístrate para visitar",
  "booking_in_community": "en",
  "booking_choose_day": "¿Qué día te gustaría visitar?",
  "booking_choose_time": "¿A qué hora te gustaría visitar?",
  "booking_today_upper": "HOY",
  "booking_now": "AHORA",
  "booking_no_slots_today": "No quedan horarios disponibles para hoy. Selecciona otro día.",
  "booking_tour_now": "Visitar ahora",
  "booking_schedule": "Programar",

  // Homepage
  "ready_tour": "¿Listo para una visita?",
  "start_touring_button": "Empieza a recorrer ahora"
  }
};

export default es;
